module.exports = __webpack_public_path__ + "img/M927.af9e019b.jpg";